import React from 'react'
import { Page, PageContent, Icon } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import { ModalPopup } from '@brainstud/react-tbl/themes/pgw/v1/components/modals'

const QuizHelp = props => (
  <ModalPopup {...props}>
    <Page>
      <PageContent>
        {props.data.component}
      </PageContent>

      <a onClick={props.app.toggleModal} className="Modal-popup-close">
        <Icon name="close" />
      </a>
    </Page>
  </ModalPopup>
)

export default QuizHelp
